// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"200":"5499fd9e","404":"d2b0d4c3","488":"df2cd65c","715":"6dbd33b9","836":"6dbd33b9"}[chunkId] + ".css";
};